import { BaseObject } from './BaseObject';
import { SVGRenderer } from '../core/SVGRenderer';
import { Point2D } from '../types';

export class Point extends BaseObject implements Point2D {
  public x: number;
  public y: number;
  public labelText: string;
  public radius: number;
  
  private circleElem: SVGCircleElement | null = null;
  private labelElem: SVGTextElement | null = null;
  private groupElem: SVGGElement | null = null;
  public scale: number = 1.0;

  constructor(
    renderer: SVGRenderer,
    x: number,
    y: number,
    labelText: string = '',
    id?: string
  ) {
    super(renderer, id);
    this.x = x;
    this.y = y;
    this.labelText = labelText;
    this.radius = renderer.config.pointRadius;
    this.render();
  }

  public render(): SVGElement {
    this.groupElem = this.renderer.createElement('g', {
      id: this.id,
      class: 'geom-point',
    });

    this.circleElem = this.renderer.createElement('circle', {
      cx: this.x,
      cy: this.y,
      r: this.radius * this.scale,
      fill: this.renderer.config.constructionColor,
      stroke: '#ffffff',
      'stroke-width': 1.5,
    });

    this.groupElem.appendChild(this.circleElem);

    if (this.labelText && this.renderer.config.showLabels) {
      this.labelElem = this.renderer.createElement('text', {
        x: this.x + 10,
        y: this.y - 10,
        fill: this.color,
        'font-size': this.renderer.config.fontSize,
        'font-weight': '600',
        'font-family': this.renderer.config.fontFamily,
      });
      this.labelElem.textContent = this.labelText;
      this.groupElem.appendChild(this.labelElem);
    }

    this.renderer.layers.objects.appendChild(this.groupElem);
    this.element = this.groupElem;
    return this.groupElem;
  }

  public setPosition(x: number, y: number): void {
    this.x = x;
    this.y = y;
    this.update();
  }

  public setScale(scale: number): void {
    this.scale = scale;
    this.update();
  }

  public update(): void {
    if (this.circleElem) {
      this.circleElem.setAttribute('cx', String(this.x));
      this.circleElem.setAttribute('cy', String(this.y));
      this.circleElem.setAttribute('r', String(this.radius * this.scale));
    }
    if (this.labelElem) {
      this.labelElem.setAttribute('x', String(this.x + 10));
      this.labelElem.setAttribute('y', String(this.y - 10));
    }
  }
}
